// Mirrors ALLOWED_UPLOAD_EXTENSIONS in backend/api/models/request.py, which is
// authoritative. Executable, script and macro-enabled formats are excluded.
export const allowedUploadExtensions = [
  'csv',
  'tsv',
  'txt',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'odt',
  'ods',
  'json',
  'xml',
  'zip',
  'png',
  'jpg',
  'jpeg',
  'gif',
];

export const uploadAcceptAttribute = allowedUploadExtensions.map((extension) => `.${extension}`).join(',');

export function validateUploadFileName(fileName: string): string | null {
  const trimmedFileName = fileName.trim();
  const extension = trimmedFileName.includes('.') ? trimmedFileName.split('.').pop()!.toLowerCase() : '';
  if (!allowedUploadExtensions.includes(extension)) {
    return `Files of type '.${extension}' cannot be uploaded`;
  }
  return null;
}
